import { ECode } from '@libs/shared';

/**
 * 统一错误码
 */
export const ERROR_CODE = {
    // 上传加密的excel后报错
    ENCRYPTED_EXCEL: ECode.EXCEL_PARSED_FAILED,
    // 需要进行人机验证
    CAPTCHA: ECode.USER_NO_AUTH_CODE_CAPTCHA,
    // AI服务 相关错误码
    AI: 22007
};
